import { useMap } from '@vis.gl/react-google-maps'
import { useEffect, useRef } from 'react'

export const TrafficLayer = (): null => {
  const map = useMap()
  const trafficLayerRef = useRef<google.maps.TrafficLayer | null>(null)

  useEffect(() => {
    if (!map) return

    // Create traffic layer
    trafficLayerRef.current = new google.maps.TrafficLayer()
    trafficLayerRef.current.setMap(map)

    // Cleanup function
    return () => {
      if (trafficLayerRef.current) {
        trafficLayerRef.current.setMap(null)
        trafficLayerRef.current = null
      }
    }
  }, [map])

  return null
}
